import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {buildReferenceBookUrl, createProvideTags,} from "@/api/ReferenceBooks/Rules/shared/helpers";
import {LkNotificationListInterface, LkNotificationListParamsInterface,} from "./LkNotificationListInterfaces";
import {lkNotificationCacheService} from "./LkNotificationCacheService";

const restApiConfig = new RESTAPIConfig();

export const LkNotificationListApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getLkNotificationList: builder.query<LkNotificationListInterface, LkNotificationListParamsInterface | void>({
            queryFn: async (params, _queryApi, _extraOptions, baseQuery) => {
                const cached = lkNotificationCacheService.get(params);

                if (cached) return {data: cached};

                const result = await baseQuery({
                    url: buildReferenceBookUrl(restApiConfig.lkNotificationList()),
                    params: params ?? undefined,
                });

                if (result.data) {
                    lkNotificationCacheService.set(params, result.data as LkNotificationListInterface);
                    return {data: result.data as LkNotificationListInterface};
                }

                return {error: result.error!};
            },
            providesTags: createProvideTags('LkNotifications'),
        }),
    }),
});

export const {useGetLkNotificationListQuery} = LkNotificationListApiSlice;
